enum DriverEditCarOwnershipType {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export default DriverEditCarOwnershipType;
